module.exports = __webpack_public_path__ + "img/free.39a38ce3.png";